// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RKTjk{align-items:center;display:flex;flex:1 1;gap:.25rem;justify-content:center;min-width:0}.RKTjk .G2z2c{appearance:none;background:none;border:none;border-radius:.25rem;color:inherit;cursor:pointer;flex-shrink:0;line-height:0;padding:.125rem}.RKTjk .G2z2c:hover:not(:disabled){background-color:#6c757d40}.RKTjk .G2z2c:disabled{cursor:default;opacity:.3}.RKTjk .G2z2c .emhQ6{font-size:1.75rem}.RKTjk .H5rrV{font-weight:700;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nav": `RKTjk`,
	"navButton": `G2z2c`,
	"chevron": `emhQ6`,
	"headerTitle": `H5rrV`
};
module.exports = ___CSS_LOADER_EXPORT___;
